import Axios from "axios";
import cookie from "js-cookie";

import { globalData } from "@/data";
import { store } from "@/redux/store";
import * as types from "@/redux/types";

export const axios = Axios.create({
    baseURL: import.meta.env.VITE_BASE_URL,
    responseType: "json",
});

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const {
            request: { status: requestStatus } = {},
            response: { status: responseStatus } = {},
        } = error;

        if (responseStatus === 401 || requestStatus === 0) {
            store.dispatch({ type: types.USER_LOG_OUT_SUCCESS });

            cookie.remove(globalData.cookieKeys.token);

            cookie.remove(globalData.cookieKeys.userId);

            cookie.remove(globalData.cookieKeys.user);

            window.location.href = "/auth/login";

            return new Promise(() => {});
        }

        return Promise.reject(error);
    },
);
